// extracted by mini-css-extract-plugin
export default {"Box":"roadmap-table-layout-module__Box--YCmqE","Box_1":"roadmap-table-layout-module__Box_1--zlkWx"};